export function getValue(value: number | null | undefined): string {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return String(value);
}
